import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// ADMIN CREATOR APIS
// Controller: infapis.php
// ================================

// 1) Get Creators (filters + pagination)
export async function getCreators(payload) {
  try {
    const fd = new FormData();

    fd.append("page_no", payload.page_no ?? 0);
    fd.append("search", payload.search || "");
    fd.append("status", payload.status || "");
    fd.append("platform", payload.platform || "");

    const res = await axios.post(`${apiBaseUrl}infapis/get_creators`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: "Failed to fetch creators"
    };
  }
}


// 2) Get KPI Stats
export async function getCreatorStats() {
  try {
    const res = await axios.get(`${apiBaseUrl}infapis/get_creator_stats`);

    return res.data;

  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: "Failed to fetch stats"
    };
  }
}


// 3) Approve Creator
export async function approveCreator(user_id,by) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("by", by);

    const res = await axios.post(`${apiBaseUrl}infapis/approve_creator`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: "Approval failed"
    };
  }
}


// 4) Suspend Creator
export async function suspendCreator(user_id,by) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("by", by);

    const res = await axios.post(`${apiBaseUrl}infapis/suspend_creator`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: "Suspension failed"
    };
  }
}
export async function getCreatorDetail(creator_id) {
  try {
    const fd = new FormData();
    fd.append("creator_id", creator_id);

    const res = await axios.post(`${apiBaseUrl}infapis/get_creator_detail`, fd);
    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}


